import { EntityModel } from '@/interfaces'
import {
  ALL_TRAVEL_SELECTION_BLOCKS_QUERY,
  CREATE_TRAVEL_SELECTION_BLOCK_MUTATION,
  DELETE_TRAVEL_SELECTION_BLOCK_MUTATION,
  FORCE_DELETE_TRAVEL_SELECTION_BLOCK_MUTATION,
  SINGLE_TRAVEL_SELECTION_BLOCK_QUERY,
  UPDATE_TRAVEL_SELECTION_BLOCK_MUTATION,
} from './graphql'
import travelEntity from '@/entities/travel/entity'

const cmsTravelSelectionBlockModel: EntityModel = {
  name: 'travelSelectionBlock',
  namePlural: 'travelSelectionBlocks',
  uniqueName: 'cmsTravelSelectionBlock',
  uniqueNamePlural: 'cmsTravelSelectionBlocks',
  path: 'cms/blocks/travel_selection_block',
  baseUrl: '/cms/blocks/travel_selection_blocks',
  translationPrefix: 'entities:cmsTravelSelectionBlock.',
  getDisplayName: (values: any) => {
    return 'Travel Selection Block'
  },
  gql: {
    getAll: ALL_TRAVEL_SELECTION_BLOCKS_QUERY,
    getSingle: SINGLE_TRAVEL_SELECTION_BLOCK_QUERY,
    create: CREATE_TRAVEL_SELECTION_BLOCK_MUTATION,
    update: UPDATE_TRAVEL_SELECTION_BLOCK_MUTATION,
    delete: DELETE_TRAVEL_SELECTION_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_TRAVEL_SELECTION_BLOCK_MUTATION,
  },
  attributes: {
    travels: {
      name: 'travels',
      label: 'entities:cmsTravelSelectionBlock.attributes.travels.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsTravelSelectionBlockModel
